import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06104e4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import {computed, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {UploadProps} from "ant-design-vue";
import {tokenManager} from "@/util/token";
import {VideoFieldType} from "@/components/business/crud/interface/FieldType";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;


const uploadList = ref<Exclude<UploadProps['fileList'], undefined>>([]);
const headers = {
  ...tokenManager.get(),
}

function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');

const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = '';
};
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string;
  }
  previewImage.value = file.url || file.preview;
  previewVisible.value = true;
  previewTitle.value =
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};

const fileList = computed(() => {
  let res: Exclude<UploadProps['fileList'], undefined> = [];
  if (props.data[props.propName]) {
    if (typeof props.data[props.propName] === 'string') {
      res.push({
        uid: props.data[props.propName],
        name: props.data[props.propName],
        status: 'done',
        url: props.data[props.propName],
      });
    } else {
      res = props.data[props.propName].map((item: string) => {
        return {
          uid: item,
          name: item,
          status: 'done',
          url: item,
        };
      });
    }
  }
  return res.concat(...uploadList.value);
})

return (_ctx: any,_cache: any) => {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_upload, {
      disabled: "",
      "list-type": "picture-card",
      "file-list": fileList.value,
      onPreview: handlePreview,
      "is-image-url": () => false
    }, null, 8, ["file-list"]),
    (previewVisible.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          footer: null,
          title: previewTitle.value,
          visible: true,
          onCancel: handleCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("video", {
              src: previewImage.value,
              controls: "",
              style: {"width":"100%"}
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})